// extracted by mini-css-extract-plugin
module.exports = {"leftSection":"LeftSection_leftSection__3fvGN","tableGroup":"LeftSection_tableGroup__3R-vw","group":"LeftSection_group__2oBay"};